import { render, staticRenderFns } from "./FarmaOrders.vue?vue&type=template&id=2e9daeba&scoped=true"
import script from "./FarmaOrders.vue?vue&type=script&lang=js"
export * from "./FarmaOrders.vue?vue&type=script&lang=js"
import style0 from "./FarmaOrders.vue?vue&type=style&index=0&id=2e9daeba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9daeba",
  null
  
)

export default component.exports